// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MMHKP6Ayh2M79cYhx5hR{align-items:center;height:32px;padding:4px 0;display:flex}.SU0v9xmdJh8fFEBiresx{padding:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `MMHKP6Ayh2M79cYhx5hR`,
	"ellipse": `SU0v9xmdJh8fFEBiresx`
};
export default ___CSS_LOADER_EXPORT___;
